import { datadogLogs } from '@datadog/browser-logs';
import { getRuntimeConfig } from './config/runtimeConfig';

let loggerInitialized = false;

export function initLogger(): void {
  if (loggerInitialized) {
    return;
  }

  const runtimeConfig = getRuntimeConfig();

  datadogLogs.init({
    clientToken: runtimeConfig.REACT_APP_DD_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    sessionSampleRate: 100,
    service: 'beetle-client',
    env: runtimeConfig.REACT_APP_DD_ENV,
  });

  loggerInitialized = true;
}

export function shutdownLogger(): void {
  if (!loggerInitialized) return;

  datadogLogs.logger.debug = () => {};
  datadogLogs.logger.info = () => {};
  datadogLogs.logger.warn = () => {};
  datadogLogs.logger.error = () => {};

  loggerInitialized = false;
  console.info('Datadog logger shut down');
}
